var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('keep-alive',{attrs:{"include":"LouFengList"}},[_c(_vm.currentTabComponent,{tag:"component",attrs:{"turnGirls":_vm.onTurnGirls,"turnGirlInfo":_vm.onTurnGirlInfo,"girlId":_vm.girlId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }